   import axios from 'axios'
 
   export const fetchUserDetail = async () => {
    try {
      const url = process.env.REACT_APP_API_URL;
      const res = await axios.get(`${url}/api/registerUserDetails`);
      return res.data; 
    } catch (error) {
      console.error('Error fetching user details:', error);
      return null;  
    }
  };